import {
    AutocompleteInput, AutocompleteArrayInput, RaRecord, ChoicesProps, NumberInput, NumberInputProps, OptionText, OptionTextElement, ReferenceInput, useCreate, useCreateSuggestionContext, useRecordContext, useTranslate,
    FormGroupContextProvider, FormGroupContext, FormGroupsContext, required, useGetMany,
    useDataProvider,
    useNotify, useRefresh, SimpleForm, ReferenceField, ResourceContextProvider, EditContextProvider
} from 'react-admin';

import {
    Box,
    BoxProps,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
    Stack,


} from '@mui/material';
import React, { useRef } from 'react';
import ClientCreate from '../../clients/ClientCreate';
import { Client } from '../../types';
import { type } from 'os';
import { ReferenceManyToManyInput } from "@react-admin/ra-relationships";
import ClientEditBase from '../../clients/ClientEditBase';
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { supabase } from '../../lib/supabaseClient'
import { CreateDialog, CreateInDialogButton, EditDialog, EditInDialogButton } from '@react-admin/ra-form-layout';
import { relative } from 'path';

const ClientInputOptions = (choice: any) => `${choice.name}`;

const OptionRenderer = (props: any) => {
    const record = useRecordContext();
    return record.id === '@@ra-create' ? (
        <div {...props}>{record.name}</div>
    ) : (
        <div {...props}>
            <span style={{ fontWeight: "600" }}>{record?.name}</span> {!!record.address && <span>| {record.address}</span>} {!!record.phone_number && <span>| {record.phone_number}</span>}
        </div>
    );
};

// const OptionRenderer = () => {
//     const record = useRecordContext();
//     return <span>{record.name}</span>;
//   };
  

const inputText = (choice: any) => `${choice.name}`;


const matchSuggestion = (filter: any, choice: any) => {
    return (
        choice.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(filter.toLowerCase())
        // || choice.last_name.toLowerCase().includes(filter.toLowerCase())
    );
};





export const ClientInputWithCreate = (props: any) => {

    const notify = useNotify();

    const checkDeceased = async (event: any) => {
        const { data, error: updateError } = await supabase
            .from('funerals')
            .select('*')
            .eq('deceased_client_id', event);


        if (updateError || !data) {
            throw updateError
        }

        if (data?.length > 0) {
            notify('Deceased Client is related to another funeral', { type: 'warning' });
        }
    }

    const translate = useTranslate();

    const [isEditDialogOpen, setIsEditDialogOpen] = React.useState(false);
    const openEditDialog = React.useCallback(() => {
        setIsEditDialogOpen(true);
    }, []);
    const closeEditeDialog = React.useCallback(() => {
        setIsEditDialogOpen(false);
    }, []);

    const [editRecordId, setEditRecordId] = React.useState(1);
    const [recordToEdit, setRecordToEdit] = React.useState<RaRecord | undefined>(undefined);


    const InputOpenDialog = (record: any) => {
        setRecordToEdit(record);
        setEditRecordId(record.id);
        setIsEditDialogOpen(true);
    }

    if (props.type == 'many') {
        return (
            <>
            <ReferenceManyToManyInput
                source="id"
                reference="clients"
                through="funeral_clients"
                using="funeral_id,client_id"
            >
                <AutocompleteArrayInput
                    label="Additional Clients"
                    fullWidth
                    filterToQuery={(searchText) => ({ 'unaccent@ilike': searchText, is_pickable: true })}
                    optionText={<OptionRenderer />}
                    // @ts-ignore
                    inputText={(record: any) => (
                        <span style={{position: 'relative', zIndex: '99999'}} onClick={() => InputOpenDialog(record)}>{record.name}</span>
                      )}
                    matchSuggestion={matchSuggestion}
                    create={<ClientCreatetDialog />}
                />
            </ReferenceManyToManyInput>
            <EditDialog
                fullWidth
                maxWidth="md"
                isOpen={isEditDialogOpen}
                open={openEditDialog}
                close={closeEditeDialog}
                resource="clients"
                id={editRecordId}
            >
            <SimpleForm>
                <ClientEditBase />
            </SimpleForm>

            </EditDialog>
            </>
        );

    } else {

        return (
            <ReferenceInput source={props.source} reference="clients">
                <AutocompleteInput
                    validate={props.source == 'deceased_client_id' ? [required()] : undefined}
                    optionText={<OptionRenderer />}
                    // optionText={ClientInputOptions}
                    filterToQuery={(searchText) => ({ 'unaccent@ilike': searchText, is_pickable: true })}
                    fullWidth
                    inputText={inputText}
                    matchSuggestion={matchSuggestion}
                    create={<ClientCreatetDialog />}
                    onChange={props.source == 'deceased_client_id' ? checkDeceased : undefined}
                    helperText={props.source == "primary_client_id" ? translate('resources.funerals.primary_required') : false}
                />
            </ReferenceInput>
        );
    }
}


const ClientCreatetDialog = (props: any) => {
    const { filter, onCancel, onCreate } = useCreateSuggestionContext();
    const [value, setValue] = React.useState(filter || '');
    const [create] = useCreate();
    const { parentRef } = props;

    const record = useRecordContext();

    const [isCreateDialogOpen, setIsCreateDialogOpen] = React.useState(true);

    const openCreateDialog = React.useCallback(() => {
      setIsCreateDialogOpen(true);
    }, []);
    const closeCreateDialog = React.useCallback(() => {
      setIsCreateDialogOpen(false);
    }, []);

    const methods = useForm();

    const onClose = (event: any, reason: any) => {
        if (reason && reason == "backdropClick")
            return;
        onCancel();
    };

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        void create(
            'clients',
            {
                data: {
                    name: value,
                    hebrew_name: formData.get('hebrew_name'),
                    address: formData.get('address'),
                    address2: formData.get('address2'),
                    city: formData.get('city'),
                    province: formData.get('province'),
                    postal_code: formData.get('postal_code'),
                    country: formData.get('country'),
                    email: formData.get('email'),
                    phone_number: formData.get('phone_number'),
                    mobile_phone_number: formData.get('mobile_phone_number'),
                    occupation: formData.get('occupation'),
                    medicare_number: formData.get('medicare_number'),
                    sin: formData.get('sin'),
                    sex: formData.get('sex'),
                    birthdate: formData.get('birthdate'),
                    place_of_birth: formData.get('place_of_birth'),
                    // marital_status_id: formData.get()
                    parent1_name: formData.get('parent1_name'),
                    parent2_name: formData.get('parent2_name'),
                    send_condolences: formData.get('send_condolences'),
                    bad_debtor: formData.get('bad_debtor'),
                },
            },
            {
                onSuccess: (data) => {
                    setValue('');
                    onCreate(data);
                },
            }
        );
        return false;
    };


    return (

        <CreateDialog
            maxWidth="md"
            fullWidth
            record={{ name: value}}
            isOpen={isCreateDialogOpen}
            open={openCreateDialog}
            close={closeCreateDialog}
            resource="clients"
            mutationOptions={{onSuccess: (data) => {
                onCreate(data);
            }}}
        >
            <SimpleForm>
                <ClientEditBase createName={value} />
            </SimpleForm>
        </CreateDialog>

        // <Dialog 
        //   open
        //   onClose={onClose}
        //   >
        //     <FormProvider {...methods}>
        //         <form onSubmit={handleSubmit}>
        //             <DialogContent sx={{width: '500px'}}>
        //                 <SimpleForm toolbar={false}>
        //                     <ClientEditBase createName={value}/>
        //                 </SimpleForm>
        //             </DialogContent>
        //             <DialogActions>
        //                 <Button type="submit">Save</Button>
        //                 <Button onClick={onCancel}>Cancel</Button>
        //             </DialogActions>
        //         </form>
        //     </FormProvider>
        // </Dialog>
    );
};


